import { startJob } from "@/Services/Ressources/API/JobService";
import { iconNames } from "@/Modules/utils/icons";
import { withNotification } from "@/Modules/utils/withNotification";

const startProcess = withNotification(async (row) => {
  return await startJob(row.ProcesKey, row.organizationUnitId);
}, {
  successTitle: "Process Started",
  successMessage: "The process was started successfully.",
  errorTitle: "Start  Process Failed",
  fallbackErrorMessage: "An error occurred while starting the process."
});

export const actions = [
  {
    label: "Start",
    icon: iconNames.play,
    variant: "success",
    tooltip: "Start process",
    handler: startProcess,
  },
];